export const ACTIVATE_CHANNEL_MANAGER = "[CHANNEL_MANAGERS] Activate";
export const ACTIVATE_CHANNEL_MANAGER_SUCCESS = "[CHANNEL_MANAGERS] Activate Success";
export const ACTIVATE_CHANNEL_MANAGER_FAIL = "[CHANNEL_MANAGERS] Activate Fail";